<form [formGroup]="form">
  <h4 class="fw-bold my-4">Filtra risorse</h4>
  <div class="row g-2 pe-1">
    <div class="col-6">
      <label class="form-label" for="risorsa">Risorsa</label>
      <input
        type="text"
        id="risorsa"
        formControlName="nomeRisorsa"
        class="form-control"
        maxlength="50"
      />
    </div>
    <div class="col-6">
      <label class="form-label" for="risorsa">Matricola</label>
      <input
        type="text"
        id="risorsa"
        formControlName="risorsa"
        class="form-control"
        maxlength="50"
      />
    </div>
    <div class="col-6">
      <label class="form-label" for="nomeResponsabile"
        >Responsabile Gerarchico</label
      >
      <input
        type="text"
        id="nomeResponsabile"
        formControlName="nomeResponsabile"
        class="form-control"
        maxlength="50"
      />
    </div>
    @if ([attori.CFO, attori.DirettoreGenerale, attori.ControllerCentrale].includes(attore)) {
    <div class="col-6">
      <label class="form-label" for="descrizioneUnitaOrganizzativaPrimoLivello">
        Unità Organizzativa Primo Livello
      </label>
      <select formControlName="descrizioneUnitaOrganizzativaPrimoLivello" class="form-select">
        <option [ngValue]="null">-</option>
        <option *ngFor="let unita of uoPrimoLivello" [ngValue]="unita.descrizione">
          {{ unita.descrizione }}
        </option>
      </select>
    </div>
    }
    <div class="col-6">
      <label class="form-label" for="idStatoPresaVisione">
        Unità Organizzativa</label>
        <input
          type="text"
          id="descrizioneUnitaOrganizzativa"
          formControlName="descrizioneUnitaOrganizzativa"
          class="form-control"
          maxlength="50"
        />
    </div>
    @if (utente.hasDelegheAttive) {
    <div class="col-6">
      <label class="form-label" for="nomeDelegante">Autorizza risorse</label>
      <select formControlName="nomeDelegante" class="form-select">
        <option [ngValue]="null">-</option>
        @if (![attori.ControllerCentrale].includes(attore)) {
        <option [ngValue]="''">Risorse proprie</option>
        }
        <option *ngFor="let delega of utente.delegheAttive" [ngValue]="delega.nomeDelegante">
          {{ delega.nomeDelegante }}
        </option>
      </select>
    </div>
    }
    <div class="col-6">
      <label class="form-label" for="modificato">
        Timesheet modificato</label>
      <select formControlName="modificato" class="form-select">
        <option [ngValue]="null">-</option>
        <option [ngValue]="true">Sì</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    <div class="col-6">
      <label class="form-label" for="approvato">
        Timesheet approvato</label>
      <select formControlName="approvato" class="form-select">
        <option [ngValue]="null">-</option>
        <option [ngValue]="true">Sì</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
    @if ([attori.ControllerCentrale].includes(attore)) {
    <div class="col-6">
      <label class="form-label" for="nomeApprovatore">Utente approvatore</label>
      <input
        type="text"
        id="nomeApprovatore"
        formControlName="nomeApprovatore"
        class="form-control"
        maxlength="50"
      />
    </div>
    }
    <div class="col-6">
      <label class="form-label" for="dataApprovazione">
        Data approvazione
      </label>
      <input type="date" id="dataApprovazione" formControlName="dataApprovazione" class="form-control"
        maxlength="50" />
    </div>
    <div class="col-12 d-flex justify-content-end mt-4 mb-4">
      <button
        (click)="search(true)"
        type="button"
        class="btn btn-outline-primary fw-semibold me-2"
      >
        Reset
      </button>
      <button
        (click)="search()"
        type="submit"
        class="btn btn-primary fw-semibold"
      >
        Cerca
      </button>
    </div>
  </div>
</form>
